import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { message } from 'antd';
import { actionforms } from './api';

const initialState = {
  feedbackloading: false,
  paginationList: [],
  scrollingData: []
};

const actions = {
  SUBMIT_FEEDBACK: 'submitFeedback/SUBMIT_FEEDBACK'
};

export const submitFeedback = createAsyncThunk(
  actions.SUBMIT_FEEDBACK,
  async (payload) => {
    const response = await actionforms(`submit`, payload);
    return response;
  }
);

export const FeedbackSlice = createSlice({
  name: 'feedback',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    // createForm
    builder
      .addCase(submitFeedback.pending, (state) => {
        state.feedbackloading = true;
      })
      .addCase(submitFeedback.fulfilled, (state, action) => {
        const { data } = action.payload;
        // console.log('payload_data', data);
        state.scrollingData = data;
        state.feedbackloading = false;
      })
      .addCase(submitFeedback.rejected, (state, action) => {
        const { message: msg } = action.error;
        state.feedbackloading = false;
        message.error(msg);
      });
  }
});

export default FeedbackSlice.reducer;
